module.exports = __webpack_public_path__ + "img/kraken.9e23a58f.png";